import $ from 'jquery';
import schema from '../../../schema/character.schema.json';

// Helper function to extract field IDs from schema properties
const getFieldIds = (properties, prefix = '') => {
  const fieldIds = [];
  if (properties && typeof properties === 'object') {
        Object.keys(properties).forEach((key) => {
        
            if (properties[key].type === 'object') {
            // Recursively get fields for nested objects
            const nestedFields = getFieldIds(properties[key].properties, `${prefix}${key}.`);
            fieldIds.push(...nestedFields);
            } else {
            fieldIds.push(`${prefix}${key}`);
            }
        });
  }
  return fieldIds;
};

const getKeys = (dictionary) => {
    return Object.keys(dictionary).map(key => key);
    }

// ---------------   GET CHAR DATA ----------------
//
// Reads the html document and returns low-level "packed" character data
//     - based on the values in Input and Text fields whose IDs match the data fields
//
// ------------------------------------------------

function getCharData( format='packed' ) {

    const chardata = {};
  
    // Get all field IDs from the schema
    const fieldIds = getFieldIds(schema.properties.chardata.properties);

    // Initialize nested objects
    for (const key of getKeys(schema.properties.chardata.properties)) {
        chardata[key] = {}
    }


  // Map form inputs to object based on schema
  fieldIds.forEach((fieldId) => {
    const [section, key] = fieldId.split('.');
    let value = $(`#${key}`).val() || '';

    // Special handling for fields that might be text instead of input
    if (key === 'myClass' || key === 'myLevel' || key === 'myRace') {
      value = $(`#${key}`).is('input') ? $(`#${key}`).val() : $(`#${key}`).text();
    }

    if (section === 'chardata') {
      chardata[key] = value;
    } else if (section in chardata) {
      chardata[section][key] = value;
    }
  });

  // IF YOU NEED "FULL" DATA - but we don't normally
  if ( format === 'complete' ) {
    const complete_character = {
        name: $('#name').val() || 'Unnamed Character',
        version: schema.properties.version.const || 0.4,
        chardata: chardata,
    };
    return complete_character
  }

  return chardata;
}

export default getCharData;